import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, Signal } from "@angular/core";

import { toSignal } from "@angular/core/rxjs-interop";

import { HEADER_DESKTOP_HEIGHT } from "@hermes/header";

import { GridFacade, GridFilterGroup } from "@hermes/states/grid-filters-state";

import { GridFilterSectionComponent } from "../grid-filter-section/grid-filter-section.component";
import { GridFilterSectionHeaderComponent } from "../grid-filter-section-header/grid-filter-section-header.component";
import { GridFilterTagsComponent } from "../grid-filter-tags/grid-filter-tags.component";

@Component({
    selector: "h-grid-filter-bar",
    standalone: true,
    templateUrl: "./grid-filter-bar.component.html",
    styleUrls: ["./grid-filter-bar.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        GridFilterSectionComponent,
        GridFilterSectionHeaderComponent,
        GridFilterTagsComponent,
        CommonModule,
    ],
})
export class GridFilterBarComponent {
    public readonly HEADER_MAIN_DESKTOP_HEIGHT = HEADER_DESKTOP_HEIGHT;
    public filterGroups: Signal<GridFilterGroup[]> = toSignal(
        this.gridFacade.filterGroups$,
        {
            initialValue: [],
        },
    );

    constructor(private readonly gridFacade: GridFacade) {}
}
